import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { Tab, TabLabel } from 'components/Tabs';
import { bem } from 'helpers/class-name';

import messages from './SkuMenuPage.messages';
import { SKU_MODIFIERS_TAB } from './useSkuMenuState';

const { element } = bem('items');

// A render helper (not a component) because Tabs reads name/children off its immediate
// children; whether the tab renders at all is decided by the caller's employee gate.
const renderModifiersTab = ({ DevPanel, venueId }) => (
  <Tab name={SKU_MODIFIERS_TAB}>
    <TabLabel>
      <span className={element('tab-with-badge')}>
        <Message message={messages.modifiersTab} />
        <span className={element('dev-label')}>dev</span>
      </span>
    </TabLabel>
    <DevPanel venueId={venueId} />
  </Tab>
);

renderModifiersTab.propTypes = {
  DevPanel: PropTypes.elementType.isRequired,
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default renderModifiersTab;
